// This file sets the first part of the version
// It is automatically updated in the build pipeline


// For development builds the version is appended with `BUILD_NUMBER-development`
// For release candidate builds it is appended with `-rcBUILD_NUMBER`
// For production builds it is set to the current release tag..17-development-0fbc685
export default "alpha (0.1.17-development-0fbc685)";